import { render } from "./BaseImage.vue?vue&type=template&id=ead46a9e&ts=true"
import script from "./BaseImage.vue?vue&type=script&lang=ts"
export * from "./BaseImage.vue?vue&type=script&lang=ts"

import "./BaseImage.vue?vue&type=style&index=0&id=ead46a9e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__